import classNames from "classnames";
import React from "react";
import { SectionProps } from "../../utils/SectionProps";
import Button from "../elements/Button";
import Input from "../elements/Input";
import GenericSection from "./GenericSection";
import SectionHeader from "./partials/SectionHeader";

const propTypes = {
  ...SectionProps.types,
};

const defaultProps = {
  ...SectionProps.defaults,
};

class SignupForm extends React.Component {
  render() {
    const {
      className,
      topOuterDivider,
      bottomOuterDivider,
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      ...props
    } = this.props;

    const outerClasses = classNames(
      "signin section",
      topOuterDivider && "has-top-divider",
      bottomOuterDivider && "has-bottom-divider",
      hasBgColor && "has-bg-color",
      invertColor && "invert-color",
      className
    );

    const innerClasses = classNames(
      topDivider && "has-top-divider",
      bottomDivider && "has-bottom-divider"
    );

    const sectionHeader = {
      title:
        "We don't store any messages or other private info, but feel free to ask us about it anyway:",
    };

    const onSubmit = () => {
      alert("Message sent!");
    };

    return (
      <GenericSection {...props} topDivider className={outerClasses}>
        <div className="container-xs">
          <div className={innerClasses}>
            <SectionHeader
              tag="h1"
              data={sectionHeader}
              className="center-content"
            />
            <div className="tiles-wrap">
              <div className="tiles-item">
                <div className="tiles-item-inner">
                  <form
                    action="https://send.pageclip.co/FwzkSOtkvFk22Ybw0nlBkVDwy7x7UoLh"
                    className="pageclip-form"
                    method="post"
                    onSubmit={onSubmit}
                  >
                    <fieldset>
                      <div className="mb-12">
                        <Input
                          label="Full name"
                          placeholder="Full name"
                          labelHidden
                          required
                          name="fullName"
                        />
                      </div>
                      <div className="mb-12">
                        <Input
                          type="email"
                          label="Email"
                          placeholder="Email"
                          labelHidden
                          required
                          name="email"
                        />
                      </div>
                      <div className="mb-12">
                        <Input
                          type="textarea"
                          label="Message"
                          placeholder="Message"
                          labelHidden
                          required
                          name="message"
                        />
                      </div>
                      <div className="mt-24 mb-32">
                        <Button
                          color="primary"
                          wide
                          type="submit"
                          className="pageclip-form__submit"
                        >
                          <span>Send</span>
                        </Button>
                      </div>
                    </fieldset>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </GenericSection>
    );
  }
}

SignupForm.propTypes = propTypes;
SignupForm.defaultProps = defaultProps;

export default SignupForm;
